import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-document",
  "use": "google-document-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-document\"><g clip-path=\"url(#google-document_clip0_2_59)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#4688F1\" /><path d=\"M3 3h10v2H3V3zm0 8h6.5v2H3v-2zm10-4H3v2h10V7z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-document_clip0_2_59\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol